// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".card__zindex[data-v-517c97f0]{z-index:99}.campaign_slide__title[data-v-517c97f0]{color:#2eac68}", ""]);
// Exports
module.exports = exports;
